import { useTranslation } from 'react-i18next';
import type { ApprovalActionRecord } from '@/types/approvals';
import { getLastReturnComment } from '@/modules/approvals/utils/returnedApprovalUtils';

interface Props {
  timeline?: ApprovalActionRecord[];
  className?: string;
  onEdit?: () => void;
  showEdit?: boolean;
}

export function ReturnedApprovalBanner({ timeline, className, onEdit, showEdit }: Props) {
  const { t } = useTranslation('workflow');
  const comment = getLastReturnComment(timeline);

  return (
    <div
      className={
        className ??
        'rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100'
      }
    >
      <p className="font-medium">{t('returned.title')}</p>
      <p className="mt-1 text-xs">
        {comment ?? t('returned.defaultComment')}
      </p>
      {showEdit && onEdit ? (
        <button
          type="button"
          onClick={onEdit}
          className="mt-2 text-xs font-medium text-primary-600 hover:underline dark:text-primary-400"
        >
          {t('returned.editRequest')}
        </button>
      ) : null}
    </div>
  );
}
